package com.sddamico.swigmore.components.layouts

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.components.pwa.PushOptIn
import com.sddamico.swigmore.components.sections.AppHeader
import com.sddamico.swigmore.components.sections.HeaderAccount
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwType
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.util.AppTab
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

/**
 * Page shell: green field, app header, and a 1180px content column (the design's container). The push
 * opt-in sits here, shown with an [account], so every signed-in screen can enroll a device.
 */
@Composable
fun PageLayout(
  title: String,
  activeTab: AppTab? = null,
  syncStatus: String? = null,
  account: HeaderAccount? = null,
  showAdmin: Boolean = true,
  content: @Composable () -> Unit,
) {
  document.title = if (title.isEmpty()) "Swigmore Poll" else "$title · Swigmore Poll"
  Div(
    attrs = Modifier.css("min-height" to "100vh", "background" to SwColor.bg, "color" to SwColor.text,
      "font-family" to SwType.body).toAttrs()
  ) {
    AppHeader(activeTab, syncStatus = syncStatus, account = account, showAdmin = showAdmin)
    if (account != null) {
      PushOptIn(Modifier.css("max-width" to "1180px", "margin" to "0 auto", "padding" to "16px 20px 0",
        "box-sizing" to "border-box"))
    }
    Main { content() }
  }
}

/** The standard 1180px content column with the design's page padding. */
@Composable
fun ContentColumn(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
  Div(
    attrs = Modifier.css("max-width" to "1180px", "margin" to "0 auto", "padding" to "28px 20px 48px",
      "box-sizing" to "border-box").then(modifier).toAttrs()
  ) { content() }
}

/** Wrapping two-column row (`flex-wrap` with per-column basis), the layout every screen uses. */
@Composable
fun Columns(gap: String = "28px", modifier: Modifier = Modifier, content: @Composable () -> Unit) {
  Div(
    attrs = Modifier.css("display" to "flex", "flex-wrap" to "wrap", "gap" to gap, "align-items" to "flex-start")
      .then(modifier).toAttrs()
  ) { content() }
}

/** A column inside [Columns]: grows from [basis], never overflows. */
@Composable
fun Column(basis: String, modifier: Modifier = Modifier, content: @Composable () -> Unit) {
  Div(attrs = Modifier.css("flex" to "1 1 $basis", "min-width" to "0").then(modifier).toAttrs()) { content() }
}
